export default {
    action: {
        add: "Ajouter",
        create: "Créer",
        validate: "Valider",
        createNew: "Créer nouveau",
        update: "Modifier",
        delete: "Supprimer",
        confirm: "Confirmer",
        cancel: "Annuler",
        close: "Fermer",
        save: "Enregistrer",
        clear: "Effacer",
        send: "Envoyer",
        search: "Rechercher",
        print: "Imprimer",
        import: "Importer",
        synchronize: "Synchroniser",
        share: "Partager",
        duplicate: "Dupliquer",
        renew: "Renouveler",
        ok: "Ok",
        retry: "Réessayer",
        REDIRECT_CALENDAR: "Créer et prendre un rdv",
        REDIRECT_FOLDER: "Créer et accéder au dossier",
        correct: 'Corriger'
    },
    common: {
        info: "Info",
        title: "Titre",
        file: "Fichier",
        url: "Url",
        default: "Défaut",
        selection: "Sélection",
        appointment: {
            status: {
                title: "Statut",    
                WAITING_ROOM: "Salle d'attente",
                SCHEDULED: "Planifié",
                HONOURED: "Honoré",
                NOT_HONOURED: "Non honoré",
                TO_VALIDATE: "À valider",
                CANCELLED: "Annulé"
            },
            patientWarningMsg: 'La récupération du patient a échoué mais vous pouvez toujours modifier ce rendez-vous.'
        },
        me: "Moi",
        yes: "Oui",
        no: "Non",
        loading: "Chargement ...",
        date: "Date",
        from: "Du",
        until: "Au",
        amount: "Montant",
        status: {
            'active': "Actif",
            'unactive': "Désactivé"
        },
        pageable: {
            showing: "Afficher {first} à {last} de {total}"
        },
        frequency: {
            EVERY_WEEK: "Toutes les semaines",
            EVERY_TWO_WEEKS: "Toutes les 2 semaines",
            EVERY_THREE_WEEKS: "Toutes les 3 semaines"
        },
        honorifics: {
            NONE: "",
            MALE: "M.",
            FEMALE: "Mme.",
            NON_BINARY: ""
        },
        gender: {
            MALE: "Homme",
            FEMALE: "Femme",
            NONE: "Non défini",
            NON_BINARY: "Autre"
        },
        patient: 'Patient',
        patients: 'Patients',
        healthPro: 'Professionnel de santé',
        healthPros: 'Professionnels de santé',
        user: 'Utilisateur',
        users: 'Utilisateurs',        
        personRole: {
            HEALTHPRO: "Médecin",
            HEALTHPROASSISTANT: "Assistant",
            HEALTHPROSTUDENT: "Etudiant en médecine"
        },
        toast: {
            error: "Une erreur est survenue",
            warning: "Action invalide",
            success: {
                add: "Création réussie",
                update: "Mise à jour réussie",
                delete: "Suppression réussie",
                cancel: "Annulation réussie",
                deactivate: "Désactivation réussie",                
            }
        },
        patientStatus: {
            WAITING: "A venir",
            LEAVE: "Terminée",
            OUT: "Patient sorti"
        },
        newInput: "Ajouter : {inputValue}",
        version: "v{version}",
        calendar: {
            future: "Futur",
            now: "Actuel",
            months: "{count} mois",
            weeks: "1 semaine | {count} semaines",
            days: "1 jour | {count} jours"
        },
        contactForm: {
            title: {
                phone: "Téléphone",
                email: "Email",
                address: "Adresse"
            },
            label: {
                phone: {
                    actionDefault: "A utiliser par défaut",
                    isDefault: "Utilisé par défaut"
                },
                address: {
                    actionDefault: "A utiliser par défaut",
                    isDefault: "Utilisée par défaut"
                },
                email: {
                    actionDefault: "A utiliser par défaut",
                    isDefault: "Utilisée par défaut"
                } 
            }
        }
    },
    error: {
        DEFAULT: "Une erreur est survenue",
        EXPRESSION_SAVE_FAILED: "Signe non enregistré",
        REQUIRED: "Donnée obligatoire",
        REDIRECT: "La redirection est impossible",
        ACTION_FORBIDDEN: "Action non autorisée",
        APPOINTMENT_TYPE_NOT_FOUND: "Type de rendez-vous inconnu",
        APPOINTMENT_TYPE_FORBIDDEN_EDIT: "Modification de type de rendez-vous non autorisée",
        INSTITUTE_WITH_ROLE_NOT_FOUND: "Institut inconnu",
        USER_FORBIDDEN: "Vous n'avez pas les droits d'effectuer cette action",
        USER_WITHOUT_AVAILABLE_MODULE: "Vous n'avez pas accès aux modules de l'application. Veuillez contacter un administrateur.",
        INSTITUTE_ADDRESS_NOT_FOUND: "Il n'y a pas d'adresse pour cet institut",
        INSTITUTE_ADDRESS_FORBIDDEN_EDIT: "La modification pour cette addresse est interdite",
        INSTITUTE_ROOM_NOT_FOUND: "Salle d'attente inconnue",
        INSTITUTE_ROOM_FORBIDDEN_EDIT: "Modification de la salle d'attente non autorisée",
        PERSON_ADDRESS_NOT_FOUND: "Adresse inconnue",
        PERSON_ELEMENT_NOT_ASSOCIATED: "L'élément n'est pas associé à la personne",
        PERSON_EMAIL_NOT_FOUND: "Adresse e-mail inconnue",
        PERSON_PHONE_NOT_FOUND: "Numéro de téléphone inconnu",
        PERSON_WITH_ROLE_NOT_FOUND: "Personne inconnue",
        USER_AUTHENTICATED_FAILED: "Echec lors de l'authentification",
        SETTINGS_WEEK_MODEL_NOT_FOUND: "Semaine type inconnue",
        SETTINGS_WEEK_MODEL_NAME_EXIST: "Une semaine type existe déjà avec ce nom",
        SETTINGS_DAY_MODEL_NOT_FOUND: "Journée standard inconnue",
        SETTINGS_DAY_MODEL_NAME_EXIST: "Il existe déjà une journée standard avec ce nom",
        APPOINTMENT_NOT_FOUND: "Rendez-vous inconnu",
        TIMESLOT_UNAVAILABLE: "Médecin indisponible à cette date",
        EMPTY_LOCATION: "La salle d'attente est obligatoire",
        HEALTH_GROUP_MEMBER_NOT_FOUND: "Institut inconnu",
        SPECIAL_DAY_PERIOD_ALREADY_EXIST: "Une journée spéciale existe déjà pour cette date",
        SPECIAL_DAY_NOT_FOUND: "Journée spéciale inconnue",
        SPECIAL_DAY_PERIOD_BEFORE_ERROR: "La date de fin ne peut pas être avant la date début",
        APPOINTMENT_DATE_IN_PAST: "Vous ne pouvez pas modifier un rendez-vous dans le passé",
        APPOINTMENT_ALREADY_FINISH: "Le rendez-vous a déjà été déclaré terminé",
        APPOINTMENT_CANCELED: "Le rendez-vous a été annulé, vous ne pouvez pas le déplacer",
        APPOINTMENT_MOVE_DOCTOR_FORBIDDEN: "Vous ne pouvez pas déplacer ce rendez-vous sur un autre médecin",
        APPOINTMENT_MOVE_TYPE_FORBIDDEN: "Vous ne pouvez pas déplacer ce rendez-vous sur un autre type de rendez-vous",
        APPOINTMENT_MOVE_PATIENT_FORBIDDEN: "Vous ne pouvez pas déplacer ce rendez-vous sur un autre patient",
        APPOINTMENT_DURATION_TOO_LONG: "La durée d'un rendez-vous ne peut pas être sur plusieurs jours",
        MOVE_APPOINTMENT_IN_PROGRESS: "Un rendez-vous est en cours de déplacement",
        DELETE_FORBIDDEN_NOT_CURRENT_ENTRY: "Suppression impossible (Cette entrée n'est pas dans une consultation courante)",
        DELETE_FORBIDDEN_LAST_ITEM: "Suppression impossible (Une seule entrée présente dans la consultation)",
        DELETE_FORBIDDEN_NOT_SAP_CURRENT_ENTRY: "Suppression impossible (Cette entrée n'est pas dans une consultation courante)",
        DELETE_FORBIDDEN_NOT_EMPTY_CONCLUSION: "La consultation n'est pas vide",
        DELETE_FORBIDDEN_CONCLUSION_WITH_ORDER_1: "Le dernier groupe de la consultation ne peut être supprimée",
        DELETE_FORBIDDEN_EXPRESSION_TITLE_GROUP: "Suppression impossible (cette entrée est utilisée dans un groupe)",
        VIDEO_NOT_FOUND: "La vidéo demandée n'existe pas",
        VIDEO_UNVAILABLE: "Pas de vidéo disponible",
        DIRECTORY_NOT_FOUND: "Le répertoire demandé n'existe pas",
        TASK_BOX_MODULE_NOT_FOUND: "Le module de tâche n'existe pas",
        APP_USE_NOT_FOUND: "L'utilisateur n'existe pas",
        USER_NOT_IN_INSTITUT: "L'utilisateur n'appartient pas à un institut",
        USER_SSN_EXIST: "L'identifiant LuxTrust est déjà attribué",
        DOCTOR_HEALTH_GROUP_MEMBER_NOT_FOUND: "Médecin inconnu",
        PERSON_NOT_SPECIFIED: "Personne non renseignée",
        INSTITUTE_NOT_SPECIFIED: "Institut non renseigné",
        INSTITUTE_WITHOUT_HEALTH_PRO_GROUP_ROLE: "Institut sans rôle défini",
        CANNOT_DELETE_LAST_INSTITUTE_ADDRESS: "La dernière adresse d'un institut ne peut être supprimée",
        PERSON_ALREADY_LINKED_WITH_INSTITUTE: "Personne déjà liée à cet institut",
        CREATE_PERSON_ERROR: "Une erreur est survenue lors de la création de la personne",
        MANDATORY_DATA_MISSING: "Données obligatoires manquantes",
        PERSON_GENDER_TYPE_ERROR: "Genre inconnu",
        PERSON_CNS_NUMBER_ERROR: "Format du matricule incorrect",
        PERSON_CNS_BIRTHDATE_ERROR: "Ce matricule ne correspond pas à une date de naissance valide",
        IS_NOT_A_DOCTOR : "L'utilisateur n'est pas un médecin",
        HAS_NO_PLANNING: "Aucun agenda partagé",
        APPOINTMENT_MANDATORY: "Le nom et la durée sont obligatoires",
        APPOINTMENT_TYPE_NAME_EXIST: "Il existe déjà un type de rendez vous avec ce nom",
        APPOINTMENT_TYPE_NOTE_LENGTH: "La note ne peut pas dépasser 255 caractères",
        NO_PATIENT: "Le patient sélectionné n'existe pas",
        FINANCIAL_GROUP_NOT_FOUND: "Groupe financier inconnu",
        FINANCIAL_CHANNEL_NOT_FOUND: "Canal financier inconnu",
        FINANCIAL_CHANNEL_AND_GROUP_ERROR: "Le canal financier n'appartient pas au groupe financier",
        FINANCIAL_BANK_ACCOUNT_NOT_FOUND: "Coordonnées bancaires inconnues",
        FINANCIAL_BANK_ACCOUNT_FORBIDDEN_EDIT: "Les coordonnées bancaires ne peuvent pas être modifiées",
        SETTINGS_CHANNEL_PERMISSION_NOT_FOUND: "Permission du canal financier inconnue",
        CNS_ALREADY_EXIST: "Le code CNS existe déjà pour une autre personne",
        RELATION_ID_AND_PATIENT_ID_ARE_NULL: "Patient inconnu",
        CNS_AFFILIATION_NUMBER_SUFFIX_LENGTH: "Le suffix du matricule doit faire 5 charactères",
        CNS_HEALTH_INSURANCE_NOT_FOUND: "Matricule inconnu",
        GET_PERSON_ERROR: "Erreur lors de la récupération de la personne",
        UPDATE_PERSON_ERROR: "Erreur lors de la mise à jour des données de la personne",
        TASKBOX_ALREADY_ASSIGN: "La mission est déjà affectée à 2 personnes",
        TASKBOX_RESULT_ALREADY_EXIST: "La mission 'Results' existe déjà",
        PATIENT_DOCUMENT_GROUP_NOT_FOUND: "Le groupe de documents n'existe pas",
        PERSON_AND_PATIENT_ALREADY_ASSOCIATED: "La personne est déjà associée au patient",
        ADD_PERSON_TO_PATIENT_ERROR: "La personne sélectionnée ne peut pas être ajoutée à ce patient",
        INSTITUTE_PID_ACTIVE_BUT_NOT_HEALTH_GROUP_PRO: "l'institut doit être de rôle Health Pro Group pour activer le PID",
        NO_DATA: "Le fichier d'envoi n'a pas pu être généré",
        HOSPI_DURATION_TOO_LONG: "La durée d'hospitalisation dépasse la limite de {days} jours.",
        INVOICE_GENERATE_ERROR: "Une erreur est survenue lors de la génération du mémoire, merci de réessayer",
        FINANCIAL_GROUP_MISSING_IBAN: "Le mémoire n'a pas pu être généré car il manque l'IBAN du groupe financier",
        SETTINGS_DAYS_BY_WEEK_MODEL_NOT_FOUND: "Paramétrage de la journée inconnu",
        CNS_AFFILIATION_NUMBER_INVALID: "Matricule non valide",
        RELATION_ID_IS_NULL: "Absence d'ID de la relation",
        CNS_NUMBER_IS_EMPTY: "Absence de matricule.",
        INSTITUTE_ID_IS_NULL: "Absence d'ID de l'institut",
        FEE_WRONG_FORMAT: "Le montant doit être un nombre décimal",
        NO_PDFS_FOUND: "Pas de pdf trouvés",
        PDF_LOADING_ERROR: "Erreur peur charger le pdf",
        TIMESLOT_PERIOD_ALREADY_EXIST: "Une semaine est déjà appliquée sur cette période",
        SETTINGS_WEEK_MODEL_USED: "La semaine est utilisée sur une période",
        INSTITUTE_EMAIL_IS_USED: "L'email est utilisé par un ou plusieurs personnels médicales",
        INSTITUTE_PHONE_IS_USED: "Le numéro de téléphone est utilisé par un ou plusieurs personnels médicales",
        INSTITUTE_ADDRESS_IS_USED: "L'adresse est utilisée par un ou plusieurs personnels médicales",
        FINANCIAL_GROUP_CODE_TOO_LONG: "Le code du groupe financier doit être de trois caractères",
        FINANCIAL_GROUP_MISA_TOO_LONG: "Le numéro Misa du groupe financier doit être de huit caractères",
        FINANCIAL_GROUP_ONLY_ONE_PID: "Ce groupe financier possède déjà un canal PID (un seul autorisé)",
        INSTITUTE_HEADER_NOT_FOUND: "Cette en-tête est introuvable",
        INSTITUTE_HEADER_CANNOT_DELETE_LAST: "Impossible de supprimer le dernier en-tête de l'institut",
        INSTITUTE_HEADER_IS_USED: "Cette en-tête est utilisé par un ou plusieurs personnels médicaux",
        PATIENT_DOCUMENT_NOT_CURRENT_ENTRY: "Ce document n'appartient pas à la consultation en cours",
        HEALTH_PRO_HAS_APPOINTMENT: "Un rendez-vous est programmé pour ce professionnel de santé",
        ENTRY_RELATION_NOT_FOUND: "Entrée inconnue",
        NOT_ENTRY_FOR_THIS_PATIENT: "Cette entrée n'est pas liée au patient",
        NEW_DOSETIMING: "Une nouvelle posologie a été définie pour un médicament de cette entrée. Continuer la suppression ?",
        ECOSYSTEM_USED_ANOTHER_ENTRY: "Un écosystem est utilisé dans une autre consultation. Continuer la suppression ?",
        HISTORY_USED_ANOTHER_ENTRY: "Un antécédent est utilisé dans une autre consultation. Continuer la suppression ?",
        MONITORING_USED_ANOTHER_ENTRY: "Un suivis est utilisé dans une autre consultation. Continuer la suppression ?",
        BASIC_USED_ANOTHER_ENTRY: "Un concept est utilisé dans une autre consultation. Continuer la suppression ?"
    },
    warn: {
        APPOINTMENT_EXIST: "Attention, des rendez-vous ont été planifiés à cette date.",
        TOO_LONG: "Attention, la durée du rendez-vous dépasse de la plage horaire disponible",
        NO_TIME_SLOT_FOR_APPT_TYPE_MSG: "Ce type de rendez-vous n'est pas paramétré pour cet horaire",
        ONE_DOCTOR_SELECTED: "Au moins un médecin doit être sélectionné",
        INVALID_DATE_TIME: "Format de date invalide"
    },
    enum: {
        languages: {
            FR: 'Français',
            EN: 'Anglais',
            DE: 'Allemand',
            ES: 'Espagnol',
            IT: 'Italien',
            PT: 'Portugais',
            NL: 'Hollandais',
            LU: 'Luxembourgeois'
        },
        weekday: {
            MONDAY: "Lundi",
            TUESDAY: "Mardi",
            WEDNESDAY: "Mercredi",
            THURSDAY: "Jeudi",
            FRIDAY: "Vendredi",
            SATURDAY: "Samedi",
            SUNDAY: "Dimanche"
        }
    },
    menu: {
        settings: 'Réglages',
        admin: 'Admin',
        logout: 'Déconnexion',
        help: 'Aide',
        tutorial: {
            videoNotDisplay: 'Votre navigateur ne prend pas en charge la lecture de vidéo',
            selectVideo: 'Sélectionner une vidéo'
        },
        idea: 'Boite à idées',
        news: 'Nouveautés eSklepios',
        version: "Version {version}",
        contactSupport: "Contacter le service technique",
        fullscreen: 'Plein écran',
        institute: 'Institut'
    },
    academic: {
        menu: {
            mycme: "my cme",
            cmePulication: "alformec",
            cmeValidation: "accreditation"
        }
    },
    office: {
        menu: {
            incomes: "recette",
            expenses: "dépenses",
            stock: "stock",
            orders: "commandes"
        }
    },
    settings: {
        notification: {
            reminderTitle: "Notifications de rappel de rendez-vous",
            isTodayReminderEnabled: "Le jour même",
            isOneDayBeforeReminderEnabled: "La veille",
            isThreeDaysBeforeReminderEnabled: "Trois jours avant",
            isOneWeekReminderEnabled: "Une semaine avant"
        },
        titleLabels: {
            title1: 'Titre 1',
            title2: 'Titre 2',
            title3: 'Titre 3',
            title4: 'Titre 4',
            title5: 'Titre 5',
            title6: 'Titre 6'
        },
        permissions : {
            institutes : "Instituts"
        },
        menu: {
            duration: "{numberMin} min",
            organization: "Institut",
            mySettings: "Mes préferences",
            appointmentTypes: "Types de rendez-vous",
            waitingRoom: "Salles d'attente",
        },
        title: {
            language: "Langue",
            appointment: "Rendez-vous",
            appointmentType: "Liste des types de rendez-vous"
        },
        tab: {
            main: "Général",
            appointmentTye: "Types de rendez-vous",
            specialDays: "Journées spéciales",
            planning: "Planning",
            dayModel: "Journées standards"

        },
        calendar: {
            noHealthPro: "Vous n'avez pas d'agenda paramétrable"
        },
        label: {
            main: {
                subtitle: {
                    calendar: "Paramétrage de l'agenda"
                },
                duration: {
                    label: "Durée d'un créneau de rendez-vous (en min)",
                    success: {
                        update: "Mise à jour de la durée du créneau réussie"
                    }
                },
                beforeDay: {
                    label: "Nombre maximum de jours à l'avance où un patient peut prendre rendez-vous",
                    success: {
                        update: "Mise à jour du nombre de jours réussie"
                    }
                },
                cancelHour: {
                    label: "Nombre minimum d'heures avant le rendez-vous où un patient peut l'annuler",
                    success: {
                        update: "Mise à jour du nombre d'heures réussie"
                    }
                },
                generalMessage: {
                    label: "Message à destination des patients",
                    success: {
                        update: "Mise à jour du message réussie"
                    }
                },
                permissions: {
                    title: "Accès à mon agenda",
                    loading: "Chargement ...",
                    empty: "Aucune permission définie",
                    access: "Accès",
                    admin: "Administration",
                    message: {
                        success: {
                            update: "Mise à jour de la permission réussie"
                        }
                    }
                },
                weekDay: "Jour à afficher dans l'agenda",
                message: {
                    success: {
                        update: "Mise à jour des jours à afficher réussie"
                    }
                }
            },
            select: {
                institutes: "Institut",
                healthpros: "Professionnel de santé"
            },
            specialDays: {
                modal: {
                    header: "Modifier les horaires d'une journée spéciale",
                    date: "Date",
                    range: "Sélectionner la période",
                    dayModel: "Journée standard",
                    period: "Période",
                    add: {
                        title: "Création d'une journée spéciale",
                    },
                    delete: {
                        title: "Suppression d'une journée spéciale",
                        message: "Vous êtes sur le point de supprimer une journée spéciale",
                    }
                },
                toast: {
                    created: "Création de la journée spéciale réussie",
                    updated: "Mise à jour de la journée spéciale réussie",
                    deleted: "Suppression de la journée spéciale réussie",
                },
                labelQuickParam: "Journée spéciale du {specialDayDate}"
            },
            weekModel: {
                message: {
                    success: {
                        update: "Mise à jour de la semaine standard réussie"
                    }
                },
                nameOfNew: "Nouvelle semaine type {counter}",
                action: {
                    add: {
                        button: "Ajouter un type de semaine"
                    }
                }
            },
            dayModel: {
                unavailable: "Modèle par défaut d'indisponibilité. Aucun paramétrage n'est requis",
                selectOrCreate: "Sélectionner ou créer une journée standard",
                form: {
                    name: "Nom",
                    timeslot: {
                        start: "Début",
                        end: "Fin",
                        delete: "Supprimer"
                    },
                    header: {
                        add: "Ajout d'une journée standard",
                        name: "Modifier le nom d'une journée standard",
                        timeslot: "Modifier les horaires d'une journée standard",
                        delete: "Suppression d'une journée standard"
                    },
                    message: {
                        delete: "Vous êtes sur le point de supprimer une journée standard",
                        success: {
                            add: "Ajout d'une journée réussi",
                            update: "Modification d'une journée réussi",
                            timeslot: "Modification des horaires d'une journée standard réussie",
                            delete: "Suppression d'une journée standard réussie"
                        }
                    }
                }
            },
            planning:{
                action: {
                    openWeekModel: "Gérer les semaines types",
                    addTimeslot: "Ajouter une période",
                    deleteSelected: "Supprimer les périodes sélectionnées"
                },
                weekModel: {
                    header: "Gestion des semaines types",
                    weekStandard: "Semaine standard"
                },
                noData: "Aucune période configurée",
                column: {
                    slot: "Période",
                    weekModel: "Semaine type appliquée"
                },
                tooltip: "Au moins une journée spéciale est incluse dans cette période. Les journées spéciales remplacent la configuration de la semaine sélectionnée.",
                modale: {
                    delete: {
                        header: "Suppression d'une période",
                        message: "Vous êtes sur le point de supprimer une période"
                    },
                    deleteSelected: {
                        header: "Suppression de périodes",
                        message: "Vous êtes sur le point de supprimer plusieurs périodes"
                    },
                    addTimeslot: {
                        header: "Ajouter une période",
                        startDate: "Date de début",
                        endDate: "Date de fin",
                        frequency: "Fréquence",
                        weekModel: "Semaine type",
                        startDateRequired: "Veuillez renseigner la date de début",
                        endDateRequired: "Veuillez renseigner la date de fin",
                        frequencyRequired: "Veuillez renseigner la fréquence",
                        weekModelRequired: "Veuillez renseigner la semaine type",
                        warning: "Si la nouvelle période chevauche une période déjà configurée, la configuration existante sera remplacée par la nouvelle."
                    }
                },
                message: {
                    success: {
                        delete: "Suppression de la période réussie",
                        update: "Modification de la période réussie",
                        add: "Ajout de la période réussi"
                    }
                }
            },
            appointmentType: {
                fieldColor: "Couleur",
                name: "Nom",
                order: "Ordre",
                duration: "Durée",
                note: "Message à destination des patients",
                offline: "Prise de rendez-vous portail",
                action: "Action",
                online: "Libre",
                patient: "Réservé aux patients de confiance",
                offlineStatus: "Indisponible",
                durationUnit: "{count} min x",
                explanationDuration: "La durée correspond au produit de la valeur saisie lors de la création et de la durée par défaut fixée dans l'onglet \"Général\".",
                delete: {
                    header: "Suppression d'un type de rendez-vous",
                    message: "Vous êtes sur le point de supprimer un type de rendez-vous"
                },
                add: {
                    header: "Ajout d'un type de rendez-vous"
                },
                update: {
                    name: "Modifier le nom du type de rendez-vous"
                },
                message: {
                    success: {
                        update: "Mise à jour du type réussie",
                        add: "Ajout du type réussi",
                        delete: "Suppression du type réussie"
                    }
                }
            },
            waitingRoom: {
                name: "Nom",
                nameRequired: "Veuillez saisir un nom",
                maxLivePlaces: 'Nombre de places maximal',
                address: "Adresse",
                noAddress: "Aucune adresse",
                byDefault: "Par défaut",
                badge: "Badge",
                noBadge: "Aucun badge",
                street: "Rue",
                action: "Action",
                add: {
                    header: "Ajout d'une salle d'attente"
                },
                edit: {
                    header: "Modification d'une salle d'attente"
                },
                delete: {
                    header: "Suppression d'une salle d'attente",
                    message: "Vous êtes sur le point de supprimer une salle d'attente"
                },
                message: {
                    success: {
                        update: "Mise à jour de la salle d'attente réussie",
                        add: "Ajout de la salle d'attente reussi",
                        delete: "Suppression de la salle d'attente réussie"
                    }
                }
            },
            instituteInformation: {
                name: "Nom",
                action: "Action",
            },
            accounting: {
                financialGroup: {
                    title: "Groupes",
                    unactive: "Le groupe financier est désactivé",
                    optionDisabled: "{name} (désactivé)",
                    table: {
                        code: "Code",
                        title: "Titre",
                        active: "Actif",
                        empty: "Aucun groupe financier"
                    },
                    message: {
                        success: {
                            update: "Mise à jour du groupe financier réussie",
                            add: "Ajout du groupe financier réussi"
                        }
                    },
                    form: {
                        header: {
                            add: "Ajout d'un groupe financier",
                            update: "Modifier un groupe financier"
                        },
                        code: "Code",
                        personalInfo: "Infos suppl.",
                        title: "Titre",
                        iban: "IBAN",
                        bic: "BIC"
                    },
                    financialChannel: {
                        empty: "Sélectionner ou créer un groupe financier",
                        add: {
                            action: "Ajouter un canal",
                            header: "Ajout d'un canal",
                            message: {
                                success: "Ajout du canal réussi"
                            }
                        },
                        permissions: {
                            title: "Permissions pour ce groupe",
                            payment: "Paiements",
                            edition: "Édition",
                            creation: "Création"
                        },
                        type: {
                            None: "Aucun",
                            BankAccount: "Compte bancaire",
                            BankCard: "Carte bancaire",
                            Cash: "Liquide",
                            LuPid: "Pid",
                            DigitalPayment: "Paiement digital",
                            LuTp: "Tp",
                            LuTpSocial: "Tp social",
                            Cancelled: "Annulé"
                        },
                        data: {
                            title: "Titre",
                            type: "Type",
                            active: "Actif",
                            bank: {
                                fullName: "Nom",
                                shortName: "Nom raccourci",
                                bic: "Code BIC",
                                iban: "IBAN"
                            }
                        },
                        update: {
                            title: "Modifier le titre du canal",
                            message: {
                                success: "Modification du canal réussie"
                            }
                        },
                        error: {
                            missingIban: "Un compte bancaire ne peut pas être actif et ne pas avoir d'IBAN"
                        }
                    }
                }
            },
            patient: {
                managementDelegate: {
                    title: "Création d'une entrée patient en mon nom",
                    loading: "Chargement ...",
                    empty: "Aucune délégation définie",
                    update: {
                        message: {
                            success: "Modification de la délégation réussie" 
                        }
                    }
                }
            },
            account: {
                institute: {
                    preference: {
                        header: "Préférence de contact pour {instituteName}",
                        headerLines: "En-tête",
                        address: "Adresse",
                        phone: "Téléphone",
                        email: "Email",
                        warning: "Ces données seront visibles sur les documents générés par l'application (ordonnances, mémoires d'honoraires) et le portail de prise de rendez-vous.",
                        message: {
                            success: "Modification des préférences réussie"
                        }
                    }
                }
            },
            task: {
                taskbox: {
                    title: "Tâches",
                    add: {
                        header: "Ajouter une tâche",
                        message: {
                            success: "Ajout d'une tâche réussi"
                        }
                    },
                    update: {
                        header: "Modifier la tâche",
                        message: {
                            success: "Modification d'une tâche réussie"
                        }
                    },
                    data: {
                        title: "Titre",
                        module: "Type de module"
                    },
                    moduleType: {
                        NONE: "Aucun",
                        PATIENT: "Patient",
                        ACCOUNTING: "Comptabilité",
                        STOCK: "Stock",
                        STAFF: "Effectif",
                        LEARNING: "Formation",
                        TEACHING: "Enseignement",
                        RESEARCH: "Recherche"
                    },
                    channelType: {
                        NONE: "Aucun",
                        RESULTS: "Résultat",
                        TWOPERSON: "Deux personnes",
                    }
                }
            }
        },
        error:{
            numberMaxChar: "Le champs doit faire moins de 255 charactères",
        },
        params: {
            title: "Réglages",
            tabs: {
                billing: "Facturation"
            },
            preferences: {
                title: "Préférences",
                subTitle: "Préférences",
                language: {
                    title: "Langue",
                    menus: "Menus",
                    snomedct: "Reconnaissance de texte",
                },
                suggestions: {
                    title: "Suggestions",
                    humanBody: "Schéma corporel",
                    neuro: "Neuro",
                    ent: "ORL",
                    thorax: "Thorax",
                    abdomen: "Abdomen",
                    lymph: "Lymph",
                },
                clinical: {
                    title: "Clinique",
                    reducedByDefault: "Consultations réduites par défaut",
                    dashboardOphtalmo: "Tableau ophtalmologie",
                },                
            },
            account: {
                details: {
                    title: 'Titre',
                    address: "Adresses",
                    contact: "Contacts",
                    email: 'Adresse',
                    mobile: "Mobile",
                    phone: 'Numéro',
                    note: "Note"
                },
                prescription: {
                    header: "En-tête",
                    labelTitleLine1: "Ligne d'en-tête 1 sur une prescription",
                    labelTitleLine2: "Ligne d'en-tête 2 sur une prescription",
                    labelCustomLine1: "Ligne d'en-tête 1",
                    labelCustomLine2: "Ligne d'en-tête 2",
                    instituteName: "Institut",
                    instituteFullName: "Nom complet",                    
                    instituteShortName: "Nom abrégé",
                    title: "En-têtes des prescriptions"
                },
                institutes: {
                    roles: {
                        admin: "Administrateur",
                        customLearningSpeaker: "Créateur de formation médicale continue",
                        customPatient: "Patient",
                        healthPro: "Médecin",
                        healthProAssistant: "Secrétaire"
                    },
                    title: "Instituts",
                    portailPatient: {
                        title: "Information portail patient",
                        parking:{
                            title:"Stationnements",
                            nameRequired: "Veuillez saisir un nom",
                            add: "Ajouter un stationnement",
                            update: "Modifier un stationnement",
                            delete: "Suppression d'un stationnement",
                            message: "Vous êtes sur le point de supprimer un stationnement",
                        } ,
                        transportStop: {
                            title: "Transport en commun",
                            nameRequired: "Veuillez saisir un nom",
                            add: "Ajouter un arrêt",
                            update: "Modifier un arrêt",
                            delete: "Suppression d'un arrêt",
                            message: "Vous êtes sur le point de supprimer un arrêt",
                        },
                        slug: {
                            title: "URL de l'institut",
                            format: 'Lettres sans accents ou chiffres, séparés par des tirets',
                            formatError: "L'url ne respecte pas le format autorisé",
                            mandatory: "L'url est obligatoire",
                            alreadyUsed: "Cette url existe déjà, veuillez en choisir une autre",
                            success: "Modification de l'url réussie",
                            error: "Erreur lors de la mise à jour de l'url"
                        },
                        generalMessage: {
                            title: "Message d'information",
                        },
                    }
                },
                title: "Compte",
                toast: {
                    add: {
                        address: "Adresse ajoutée avec succès",
                        email: "Adresse email ajoutée avec succès",
                        phone: "Numéro de téléphone ajouté avec succès",
                        header: "En-tête ajouté avec succès",
                    },
                    delete: {
                        address: "Adresse supprimée avec succès",
                        email: "Adresse email supprimée avec succès",
                        phone: "Numéro de téléphone supprimé avec succès",
                        parking: "Parking supprimé avec succès",
                        stop: "Arrêt supprimé avec succès",
                        header: "En-tête supprimé avec succès",
                    },
                    update: {
                        address: "Adresse modifiée avec succès",
                        email: "Adresse email modifiée avec succès",
                        phone: "Numéro de téléphone modifié avec succès",
                        information: "Informations modifiées avec succès",
                        header: "En-tête modifié avec succès",
                    }
                },
                subTitle: "Données personnelles",
                portailPatient: {
                    title: "Information portail patient",
                    fees: "Tarifs",
                    meanOfPayement: "Moyens de paiements",
                    presentation: "Présentation",
                    diploma: "Diplômes",
                    teleconsultation: "Téléconsultation disponible",
                    openToNewPatient: "Ouvert aux nouveaux patients",
                    showAgenda: "Afficher les horaires",
                    showContact: "Afficher sur le portail",
                    schedule: "Horaires",
                    complementaryInformation: "Informations complémentaires",
                    generalMessage: "Message d'information",
                    slug: {
                        title: "URL sur le portail",
                        format: 'Lettres sans accents ou chiffres, séparés par des tirets',
                        formatError: "L'url ne respecte pas le format autorisé",
                        mandatory: "L'url est obligatoire",
                        alreadyUsed: "Cette url existe déjà, veuillez en choisir une autre",
                        success: "Modification de l'url réussie",
                        error: "Erreur lors de la mise à jour de l'url",
                        noInstituteSlugs: "Aucun institut disponible sur le portail"
                    },
                }
            },
            institute: {
                title: "Institut",
                subTitle: "Données de l'institut"
            },
            patient: {
                title: "Dossiers patient",
                subTitle: "Données du patient"
            },
            docPatient: {
                title: "Documents Patient",
                subTitle: "Documents du patient"
            },
            calendar: {
                title: "Agenda",
                subTitle: "Agenda"
            },
            task: {
                title: "Tâches",
                subTitle: "Tâches"
            },
            waitingRoom: {
                title: "Salles d'attente"
            },
            tasks: {
                title: "Tâches",
                subTitle: "Tâches",
                patientnote: "Note",
                clinic: "Note clinique",
                admin: "Note administrative"
            },
            billing: {
                title: "Facturation",
                subTitle: "Facturation"
            },
            permission: {
                title: "Permissions",
                subTitle: "Permissions",
                update: "Permission modifiée"
            },
            notification: {
                title: "Notifications",
                subTitle: "Notifications"
            }
        },
        permission: {
            viewUsers: "Voir les utilisateurs",
            editUsers: "Modifier les utilisateurs",
            writePrescriptions: "Écrire des ordonnances",
            viewAppointments: "Voir les rendez-vous",
            empty: "Aucune permission",
            roles: {
                admin: {
                    label: "Administration de l'institut",
                    ADMIN_INSTITUTE: "Administration de l'institut",
                },
                prescription: {
                    label: "Prescription",
                    WRITE_PRESCRIPTION: "Créer/modifier une prescription",
                    READ_PRESCRIPTION: "Lire une prescription",
                    SIGN_PRESCRIPTION: "Signer une prescription"
                },
                task: {
                    label: "Tâches / Missions",
                    ACCESS_TASK: "Accès module des tâches"
                },
                patient: {
                    label: "Patient",
                    ADD_PATIENT_DOCUMENT: "Créer un document administratif",
                    MODIFY_PATIENT_DATA: "Modifier le dossier clinique patient",
                    READ_PATIENT_DATA: "Consulter le dossier clinique des patients rattachés à l'institut",
                    DELETE_PATIENT_DOCUMENT: "Supprimer un document administratif",
                    EDIT_PATIENT_ADMIN_DATA: "Modifier données administratives d'un patient"
                },
                planning: {
                    label: "Agenda",
                    CREATE_PLANNING: "Créer un planning",
                    ACCESS_PLANNING: "Accès module agenda",
                    MODIFY_PLANNING: "Editer un planning",
                    OWNER_PLANNING: "Agenda personnel"
                },
                accounting: {
                    label: "Gestion comptable",
                    ACCESS_ACCOUNTING: "Accès module compta"
                }
            },
            datatableTitle: "Liste des professionnels de santé",
            title: "Permissions pour {name} "
        }
    },
    layout: {
        agenda: "Agenda",
        task: "Tâches",
        patient: "Patient",
        waitingroom: "Salle d'attente",
        finance: "Compta",
        forum: "Messagerie",
        settings: "Paramètres",
        material: "Matériel",
        fastPatientCreation: 'Nouveau Patient',
        staff: "Effectif"
    },
    admin: {
        subMenu: {
            title: "Administration",
            institute: "Instituts",
            medicalPerson: "Professionnels de santé",
            permissions: "Permissions",
            financialGroups: "Groupes financiers",
            notifications: "Notifications"
        },
        
        financialGroup: {
            datatableTitle: "Liste des groupes financiers communs",
            search: "Recherche",
            table: {
                title: "Nom",
                code: "Code",
                active: "Actif",
                empty: "Aucun groupe financier",
                misaNumber: "Numéro Misa",
                personalInfo: "Infos suppl.",
                medicalPerson: "Professionnels de santé"
            },
            form: {
                add: {
                    header: "Ajouter un groupe financier commun",
                    message: {
                        success: "Ajout du groupe financier commun réussi"
                    }
                },
                update: {
                    header: "Modifier un groupe financier commun",
                    message: {
                        success: "Modification du groupe financier commun réussie"
                    }
                },
                code: "Code",
                title: "Nom",
                misaNumber: "Numéro Misa",
                personalInfo: "Infos suppl.",
                active: "Actif"
            },
            person: {
                title: "Professionnels de santé du groupe {title}",
                search: "Recherche",
                table: {
                    empty: "Aucun professionnel de santé",
                    name: "Nom et prénom",
                    role: "Role",
                    active: "Actif",
                    isOwner: "Administrateur du groupe",
                    delete: "Supprimer"
                },
                form: {
                    institute: "Institut",
                    person: "Professionnel de santé",
                    isOwner: "Administrateur du groupe",
                    ownerWarning: "Un seul administrateur possible. Cette action enlèvera les droits d'administration existant."
                },
                add: {
                    message: {
                        success: "Ajout du professionnel de santé réussi"
                    }
                },
                update: {
                    header: {
                        confirm: "Modification de l'administrateur"
                    },
                    message: {
                        success: "Modification du professionnel de santé réussie"
                    }
                },
                delete: {
                    modale:{
                        header: "Suppression de l'accès pour le professionnel de santé",
                        message: "Vous êtes sur le point de supprimer l'accès au groupe financier pour un professionnel de santé",
                        messageOwner: "Vous êtes sur le point de supprimer l'accès au groupe financier pour l'administrateur"
                    },
                    message: {
                        success: "Suppression de l'accès pour le professionnel de santé réussie"
                    }
                }
            }
        },
        institute: {
            search: "Recherche",
            table: {
                name: "Nom",
                instituteRole: "Role",
                active: "Actif",
                empty: "Aucun institut",
                admin: "Administrateur",
                update: "Modifier"
            },
            label: {
                add: {
                    header: "Ajouter un institut",
                    message: {
                        success: "Ajout de l'institut réussi"
                    }
                },
                update: {
                    header: "Modifier un institut",
                    message: {
                        success: "Modification de l'institut réussie"
                    }
                }
            },
            form: {
                data: "Information",
                name: "Nom",
                shortName: "Nom abrégé",
                role: "Role",
                address: "Addresse",
                street: "N° et rue",
                locality: "Ville",
                postalCode: "Code postal",
                country: "Pays",
                userAdmin: "Administrateur",
                options: "Options",
                pidActivation: "PID",
                fastPatientCreationActive: 'Création rapide de patients',
                ophthalmoDashboard: 'Dashboard ophtalmo',
                externalId: "ID externe",
            },
            person: {
                title: "Administrateurs de l'institut {name}",
                search: "Recherche",
                table: {
                    empty: "Aucun administrateur",
                    firstname: "Prénom",
                    lastname: "Nom",
                    role: "Rôle"
                },
                add: {
                    message:
                    {
                        success: "Ajout de l'administrateur réussi"
                    }
                },
                header: {
                    generalInfo: "Informations générales",
                    options: "Options"
                },
                form: {
                    firstname: "Prénom",
                    lastname: "Nom",
                    gender: "Genre",
                    birthdate: "Date de naissance",
                    title: "Titre",
                    role: "Type",
                    misaNumber: "Code médecin",
                    nlpPref: "Langue Snomed CT",
                    ssnLt: "Identifiant Luxtrust",
                    favoritePhone: "Téléphone",
                    favoriteEmail: "Email",
                    favoriteLanguage: "Langues parlées",
                    portalPatientModule: "Portail patient",
                    iban: "IBAN",
                    bic: "BIC"
                }
            }
        },
        medicalPerson: {
            table: {
                name: "Professionnel",
                active: "Actif",
                institut: "Instituts",
                role: "Rôle",
                empty: "Aucun professionnel",
                update: "Modifier"
            },
            institute: {
                title: "Instituts de {name}",
                search: "Recherche",
                table: {
                    empty: "Aucun institut",
                    name: "Nom de l'institut",
                    role: "Role",
                    active: "Status",
                    isAdmin: "Administrateur",
                    edit: "Modifier",
                    delete: "Supprimer"
                },
                form: {
                    institute: "Institut",
                    adminPermission: "Administrateur"
                },
                add: {
                    message: {
                        success: "Ajout de l'institut réussi"
                    }
                },
                edit: {
                    message: {
                        success: "Modification de l'institut réussie"
                    }
                },
                delete: {
                    modale:{
                        header: "Suppression de la personne",
                        message: "Vous êtes sur le point de supprimer une personne liée à l'institut"
                    },
                    message: {
                        success: "Suppression du professionnel de santé réussie"
                    }
                }
            },
            form: {
                header: {
                    add: "Ajouter un professionnel de santé",
                    update: "Modifier un professionnel de santé"
                },
                message: {
                    success: {
                        add: "Ajout du professionnel de santé réussi",
                        update: "Modification du professionnel de santé réussie"
                    }
                }
            }
        },
        notifications: {
            message: {
                success: {
                    add: "Ajout du template de notification réussi",
                    update: "Modification du template de notification réussie"
                }
            },
        }
    },
    calendar: {
        header: {
            weekDays: "Du {first} au {last} ",
            todayButton: "Aujourd'hui",
            pastButton: "Précédent",
            nextButton: "Suivant",
            withoutAppointment: "Sans RDV",
            tab: {
                day: "Jour",
                week: "Semaine"
            },
            appointment: "Rendez-vous pour :",
            moveAppointment: "Déplacement du rendez-vous du {date} de :"
        },
        menu: {
            calendar: "Calendrier"
        },
        alt: {
            patient: "Patient"
        },
        label: {
            notAccess: "Vous n'avez accès à aucun agenda. Pour avoir un agenda, veuillez contacter l'administrateur de votre institut.",
            forbidden: "{name} n'a pas accès au module agenda",
            update: {
                header: "Modification du rendez-vous"
            },
            add: {
                patientWithoutAppointmentHeader: "Nouveau patient sans rendez-vous",
                header: "Nouveau rendez-vous",
                form: {
                    date: "Date",
                    time: "Heure",
                    duration: "Durée (en minutes)",
                    appointmentType: "Type de rendez-vous",
                    patient: "Patient",
                    portalPatient: "Rendez-vous pris par",
                    healthPro: "Professionnel de santé",
                    comment: "Commentaire",
                    departure: "Heure du départ",
                    arrival: "Arrivée en salle d'attente",
                    created: "Créé le ",
                    createdAt: "{date} à {time}",
                    createdAtBy: "{date} à {time} par {author}",
                    addPerson: "Nouveau patient",
                    lastname: "Nom",
                    firstname: "Prénom",
                    favoritePhone: "Téléphone",
                    mobile: "Mobile",
                    mail: "Email",
                    isPatientWithoutAppointment: "Sans RDV",
                    portalError: 'Une erreur est survenue pendant le chargement du patient.'
                }
            },
            delete:{
                action: "Annuler le rendez-vous"
            },
            move: {
                action: "Déplacer le rendez-vous",
                disabled: "Un rendez-vous est déjà sélectionné afin de le déplacer"
            },
            message: {
                success: {
                    add: "Ajout du rendez-vous réussi",
                    update: "Modification du rendez-vous réussie"
                },
                error:{
                    commentLength: "Le champ doit faire moins de 256 caractères"
                }
            },
            settings: {
                header: "Journée spéciale du {date}"
            },
            existAppointment: {
                header: "Un rendez-vous est déjà programmé",
                message: {
                    create: "Un rendez-vous a déjà été programmé sur ce créneaux. Souhaitez-vous continuer la création ? ",
                    update: "Un rendez-vous a déjà été programmé sur ce créneaux. Souhaitez-vous continuer la modification ? "
                }
            },
        },
        appointment: {
            action: {
                finish: "Confirmer le départ",
                patientStatus: "Consultation",
                start: "Confirmer l'arrivée",
                restart: "Confirmer le retour",
            },
            delete: {
                modale:{
                    header: "Annulation du rendez-vous",
                    message: "Vous êtes sur le point d'annuler un rendez-vous"
                },
                message: {
                    success: "Annulation du rendez-vous réussie"
                }
            }
        },
        waiting: {
            title: "Salles d'attente",
            room: {
                default: "Inconnue",
                location: "Salle d'attente"
            },
        },
        history: {
            title: "Historique",
        },
        withoutAppointment: {
            title: "Sans rendez-vous",
        }
    },
    thirdPerson: {
        create: {
            title: {
                private: "Créer personne tierce pour {name}",
                pro: "Créer professionnel de santé pour {name}",
            },
            form: {
                firstname: "Prénom",
                lastname: "Nom",
                address: "Adresse",
                street: "N° et rue",
                postalCode: "Code postal",
                locality: "Ville",
                country: "Pays",
                favoritePhone: "Téléphone",
                mobile: "Mobile",
            },
            message: {
                success: {
                    add: "Ajout de la personne réussi"
                },
            }
        },        
    },
    healthPro: {
        select: "Choisir un professionnel de santé",
        search: {
            placeholder: "Nom ...",
            noResult: "Pas de résultats",
        },
    },
    patient: {
        common: {
            bio: "Bio",
            biology: "Biologie",
            imaging: "Imagerie",
            medication: "Médicaments",
            report: "Rapport",
            reports: "Rapports",
            certificate: "Certificat",  
            certificates: "Certificats",
        },
        addMedication: {
            placeholder: "Nom ou DCI ...",
            commercialNames: "Noms commerciaux",
            singleSubstances: "Substances",
            multipleSubstances: "Substances multiples",
        },
        addMonitored: {
            childFollowUp: "Suivi enfant",
            adultFollowUp: "Suivi adulte",
            pregnancyFollowUp: "Suivi grossesse",
            travelFollowUp: "Suivi voyage",
            favorites: "Favoris",
        },        
        addHistory: {
            stroke: "AVC",
            dementia: "Démence",
            parkinson: "Parkinson",
            epilepsy: "Epilepsie",
            migraine: "Migraine",
            adhd: "ADHS",
            depressiveDisorder: "Trouble dépressif",
            anxietyDisorder: "Trouble anxieux",
            bipolarDisorder: "Trouble bipolaire",
            addictionTo: "Dépendance à",
            anorexia: "Anorexie",
            bulimia: "Boulimie",
            autisticDisorder: "Trouble autistique",
            schizophrenia: "Schizophrénie",
            refractionDisorders: "Troubles de la réfraction",
            refractionDisordersRightEye: "Troubles de la réfraction oeil droit",
            refractionDisordersLeftEye: "Troubles de la réfraction oeil gauche",
            cataract: "Cataracte",
            cataractRightEye: "Cataracte oeil droit",
            cataractLeftEye: "Cataracte oeil gauche",
            glaucoma: "Glaucome",
            glaucomaRightEye: "Glaucome oeil droit",
            glaucomaLeftEye: "Glaucome oeil gauche",
            hearingLoss: "Hypoacousie",
            hearingLossRightEar: "Hypoacousie oreille droite",
            hearingLossLeftEar: "Hypoacousie oreille gauche",
            edentulism: "Edentement",
            adenoidectomy: "Adénoïdectomie",
            tonsillectomy: "Amygdalectomie",
            copd: "BPCO",
            asthma: "Asthme",
            congenitalHeartDefect: "Anomalie cardiaque congénitale",
            coronaryArteryDisease: "Coronaropathie",
            hypertensiveHeartDisease: "Cardiopathie hypertensive",
            atrialFibrillation: "Fibrillation auriculaire",
            valvularHeartDisease: "Valvulopathie cardiaque",
            venousInsufficiency: "Insuff.veineuse",
            hepaticSteatosis: "Stéatose hépatique",
            cirrhosis: "Cirrhose",
            appendectomy: "Appendicectomie",
            cholecystectomy: "Cholécystectomie",
            malformativeUropathy: "Uropathie malformative",
            malformativeUropathyRight: "Uropathie malformative droite",
            malformativeUropathyLeft: "Uropathie malformative gauche",
            renalInsufficiency: "Insuff.rénale",
            renalLithiasis: "Lithiase rénale",
            benignProstaticHyperplasia: "HBP",
            pregnancy: "Grossesse",
            menopause: "Ménopause",
            cesareanSection: "Césarienne",
            hysterectomy: "Hystérectomie",
            oophorectomy: "Ovariectomie",
            oophorectomyRight: "Ovariectomie droite",
            oophorectomyLeft: "Ovariectomie gauche",
            scoliosis: "Scoliose",
            hipOsteoarthritis: "Coxarthrose",
            hipOsteoarthritisRight: "Coxarthrose droite",
            hipOsteoarthritisLeft: "Coxarthrose gauche",
            kneeOsteoarthritis: "Gonarthrose",
            kneeOsteoarthritisRight: "Gonarthrose droite",
            kneeOsteoarthritisLeft: "Gonarthrose gauche",
            hipProsthesis: "Prothèse hanche",
            hipProsthesisRight: "Prothèse de hanche droite",
            hipProsthesisLeft: "Prothèse de hanche gauche",
            kneeProsthesis: "Prothèse genou",
            kneeProsthesisRight: "Prothèse du genou droite",
            kneeProsthesisLeft: "Prothèse du genou gauche",
            atopicDermatitis: "Dermatite atopique",
            acne: "Acnée",
            psoriasis: "Psoriasis",
            hypothyroidism: "Hypo-thyroïdie",
            hyperparathyroidism: "Hyper-parathyroïdie",
            hypertension: "HTA",
            diabetes: "Diabète",
            dyslipidemia: "Dyslipidémie",
            hyperuricemia: "Hyperuricémie",
            bacterialPneumonia: "Pneumonie bactérienne",
            toxoplasmosis: "Toxoplasmose",
            allergy: "Allergie",
            brainCancer: "Cancer cérébral",
            lungCancer: "Cancer pulmonaire",
            colonCancer: "Cancer du colon",
            pancreaticCancer: "Cancer du pancréas",
            prostateCancer: "Cancer de la prostate",
            breastCancer: "Cancer du sein",
            breastCancerRight: "Cancer du sein droit",
            breastCancerLeft: "Cancer du sein gauche",
            leukemia: "Leucémie",
            favorites: "Favoris",
            left: "gauche",
            right: "droit",
            in: "en",
            yearsAgo: "il y a",
            years: "ans",
            atAge: "à l'âge de",
            inChildhood: "dans l'enfance",
            since: "depuis",
            sinceAge: "depuis l'âge de",
            sinceChildhood: "depuis l'enfance",
            fatherSide: "chez le père",
            motherSide: "chez la mère",
            rightAbbr: "D",
            leftAbbr: "G",
        },
        addEcosystem: {
            job: "Métier:",
            workTime: "Temps de travail:",
            hoursPerWeek: "heures par semaine",
            workTimeLabel: "Temps de travail: h/sem",
            noPartner: "Sans partenaire",
            inCouple: "En couple",
            parents: "Parents:",
            children: "Enfants:",
            pets: "Animaux domestiques:",
            petsValue: "Animaux:",
            violence: "Violences:",
            autonomousAtHome: "Autonome au domicile",
            livesOnFloor: "Vit au",
            floor: "étage",
            livesOnFloorLabel: "Vit au ... étage",
            nursingHome: "En maison de soins",
            walkingAid: "Marche avec aide:",
            homeHelp: "Aides à domicile:",
            sleepLatency: "Temps d'endormissement:",
            nightWakings: "Réveils nocturnes:",
            averageSleepDuration: "Durée de sommeil moyen:",
            physicalActivity: "Activité physique:",
            drinks: "Boissons:",
            diet: "Régime alimentaire:",
            noSmoking: "Pas de tabagisme",
            smoking: "Tabagisme:",
            cigarettesPerDay: "cigarettes par jour",
            smokingLabel: "Tabagisme: ... cig./j",
            noAlcohol: "Pas d'alcool",
            alcohol: "Alcool:",
            glassesPerWeek: "verres standard par semaine",
            alcoholLabel: "Alcool: ... verres/sem",
            noDrugs: "Pas de drogues",
            cannabis: "Cannabis:",
            cocaine: "Cocaïne:",
            opioids: "Opioïdes:",
            favorites: "Favoris",
            left: "gauche",
            right: "droit",
            in: "en",
            yearsAgo: "il y a",
            years: "ans",
            atAge: "à l'âge de",
            since: "depuis",
            sinceAge: "depuis l'âge de",
        },
        no_entry : "Aucune entrée",
        header: {
            report: "Rapport",
            reportWithHistory: "Rapport avec antécédents",
            reportWithHistoryShort: "Rapport complet",
            operativeReport: "CR opératoire",
            lab: "Laboratoire",
            pharma: "Pharmacie",
            billing: "Mémoire"
        },
        expression: {
            addSigns: "Rajouter signes ...",
            isCorrected: "edité",
            history: "Historique",
            doctor: {
                importedFor: "Importé pour :",
                by: "par {secondaryHealthPro}",
                for: "pour",
            }
        },
        expressionMoreMenu: {
            createGroup: "Créer groupe",
            rename: "Renommer",
            correct: "Corriger",
            moveToMonitored: "Déplacer vers Suivi",
            moveToHistory: "Déplacer vers Antécédents",
            moveToEcosystem: "Déplacer vers Ecosystème",
            removeFromBar: "Enlever de la barre",
            nlp: "NLP",
        },
        conclusionGroup: {
            numberedTitle: "Groupe {number}",
            placeholder: "Plan, prescriptions ...",
        },
        suggestion: {
            sign: {
                Groups: "Groupes",
                Measures: "Général",
                CranialNerves1: "Paires crâniennes",
                NeuroPeriph: "Neuro périphérique",
                MotorCoordination: "Equilibre, coordination",
                Head: "Tête",
                Ent: "ORL",
                Thorax: "Thorax",
                Abdomen: "Abdomen",
                ShoulderL: "Epaule G",
                ShoulderR: "Epaule D",
                EllbowL: "Coude G",
                EllbowR: "Coude D",
                UpperArmL: "Bras G",
                UpperArmR: "Bras D",
                ForeArmL: "Avant-bras G",
                ForeArmR: "Avant-bras D",
                WristL: "Poignet G",
                WristR: "Poignet D",
                HandL: "Main G",
                HandR: "Main D",
                HipL : "Hanche G",
                HipR : "Hanche D",
                ThighL: "Cuisse G",
                ThighR: "Cuisse D",
                KneeL: "Genou G",
                KneeR: "Genou D",
                LowerLegL: "Jambe G",
                LowerLegR: "Jambe D",
                AnkleL: "Cheville G",
                AnkleR: "Cheville D",
                FootL: "Pied G",
                FootR: "Pied D",
                Lymph: "Lymphatique",
            },
            conclusion: {
                adminPerso: "Administratif / Perso",
            },
        },
        delegate: {
            title: 'Créer une entrée',
            label: 'Au nom de :',
            me: ' (moi) '
        },
        search: {
            placeholder: "Nom ou matricule ...",
            noResult: "Pas de résultats",
            new: "Créer nouveau patient",
            invalidDate: "date non valide",
            tooLong: "matricule trop long",
            invalidChecksum: "suffixe incorrect",
            newPatient: "nouveau patient",
        },
        create: {
            title: "Créer un patient pour {name}",
            form: {
                cns: "Matricule",
                firstname: "Prénom",
                lastname: "Nom",
                mail: "Email",
                birthdate: "Date de naissance",
                gender: "Genre",
                address: "Adresse",
                street: "N° et rue",
                postalCode: "Code postal",
                locality: "Ville",
                country: "Pays",
                favoritePhone: "Téléphone",
                mobile: "Mobile",
                import: "Coller depuis le presse-papiers",
                importCreate: "Créer un patient depuis le presse-papiers",
            },
            toast: {
                success: "Les informations ont été récupérées automatiquement.",
                error: "Erreur lors de la lecture du presse‑papiers.",
                missingBirthdate: "Date de naissance manquante",
                emptyClipboard: "Presse‑papiers vide",
                emptyClipboardDetail: "Aucun texte valide à coller."
            },
            message: {
                success: {
                    add: "Ajout du patient réussi"
                },
                mandatory: "Saisir soit le matricule, soit la date de naissance"
            }
        },
        rightBar: {
            subtitle: {
                monitoring: "Suivis",
                treatment: "Traitement",
                history: "Antécédents",
                ecosystem: "Ecosystème"
            },
            vaccine: "Vaccins",          
        },
        imageViewer: {
            syncZoom: "Sync. zoom",
            syncPan: "Sync. déplacement",
            close: "Fermer (Esc)",
            zoomIn: "Zoom avant (+)",
            zoomOut: "Zoom arrière (-)",
            resetView: "Réinitialiser (0)",
            scroll: "Scroll",
            zoom: "Zoom",
            zoomInOut: "Zoom in/out",
            reset: "Réinitialiser",
            pan: "Déplacer",
            closeShort: "Fermer"
        },
        ophtalmo: {
            title: "Ophtalmo",
            correctiveLenses: "Verres correcteurs",
            eyeGlasses: "Lunettes",
            contactLenses: "Lentilles",
            near: "Près",
            distant: "Loin",
            intermediate: "Intermédiaire",
            bifocal: "Bifocal",
            progressive: "Progressive",
            highAmetropy: "Amétropie > 6D",           
            rigid: "LRPG",
            rigidKeratoconus: "LRPG - Kératocône",
            rigidHighAmetropy: "LRPG - Amétropie > 6D",
            leftEye: "Œil Gauche",
            rightEye: "Œil Droit",
            os: "OG",
            od: "OD",
            ou: "ODG",            
            current: "Actuel",
            previous: "Précédent",
            tonometer: "Tonomètre",
            iop: "PIO",
            slitLamp: "Lampe à fente",
            pachymetry: "Pachymétrie",
            topography: "Topographie",
            ultrasound: "Echographie",
            biometrics: "Biométrie",
            slitLampFindings: "Observations",
            refraction: "Réfraction",
            objective: "Objectif",
            subjective: "Subjectif",
            final: "Final",
            sph: "SPH",
            cyl: "CYL",
            axs: "AXE",
            va: "VA",
            add: "ADD",
            nva: "NVA",
            fundus: "Fond d'oeil",
            visualField: "Champ visuel",            
            oct: "OCT",
            keratometry: "Kératométrie",
            k1: "K1",
            k2: "K2",
            diopter: "D",
            noHistory: "Pas d'antériorités",
            export: {
                success: "Données envoyées au réfracteur"
            }
        },
        resultDocument: {
            createStructuredData: "Créer données structurées",
            notInterpretable: "Le groupe contient déjà des données. Création de données structurées désactivée.",
            file: "Fichier {mime}",
            cannotDisplay: "Ne peut être affiché. Téléchargement possible.",
        },
        document: {
            pid: "PID",
            paid: "Payé 100%",
            unpaid: "Non payé",
            firstDay: "Du",
            lastDay: "Au",
            selectFinancialGroup: "Sélectionner groupe",
            warningInvoiceExists: "Un mémoire existe déjà",
            newBio: "Nouvelle bio",
            finalizeTo: "Finaliser dans",
            imaging: {
                general: "Imagerie",
                rxShort: "Rx",
                rxFull: "Radiographie",
                usShort: "Echo",
                usFull: "Echographie",
                ct: "Scanner",
                mrt: "IRM",
                petScan: "Pet-Scanner",
                other: "Autre",
            },
            healthPro: {
                medicalSpecialty: "Avis médical",
                nurse: "Infirmière",
                physio: "Kiné",
                ergo: "Ergo",
                speech: "Orthophoniste",
                podiatrist: "Podologue",
                pedicurist: "Pédicure",
                dietitian: "Diététicienne",
                psychotherapist: "Psychothérapeute",
                psychologist: "Psychologue",
                psychomotor: "Psychomotricien(ne)",
                midwife: "Sage-femme"
            },
            luBill: {
                additionalInfo: "Complément d'information",
            },
            luBilledAct: {
                date: "Date",
                mainLocation: "Lieu",
                subLocation: "Etablissement",
                applyHospiClassToNextActs: "Appliquer classe {actClass} dès ce jour",
            },
            luBillAddon: {
                separateDates: "Séparer dates",
                codeOrAct: "Code ou acte  ...",
                acts: "Actes",
                generalActs: "Actes généraux",
                technicalActs: "Actes techniques",
                labActs: "Actes laboratoire",
                withSupplement: "+ suppl.",
                personalActs: "Actes personnels",
                hospitalisation: "Hospitalisation",
                prefix: "Préfixe",
                removePrefix: "Aucun préfixe",
                suffix: "Suffixe",
                executor: "Exécutant",
                surgeryAssistance: "Assistance opératoire",
                customAct: {
                    description: "Descriptif",
                    addCustomAct: "Rajouter acte personnel",
                },
                favoriteAct: {
                    description: "Descriptif",
                },
            },
            variableResolver: {
                patient:   {
                    title: "Patient",
                    variable: {
                        patientfirstname:   "Prénom",
                        patientlastname:    "Nom",
                        patientfullname:    "Nom complet",
                        patientbirthdate:   "Date de naissance",
                        patientage:         "Age",
                        patientphone:       "Téléphone",
                        patientstreet:      "Rue",
                        patientcity:        "Ville",
                        patientfulladdress: "Adresse complète",
                        patientemail:       "Email",
                    }
                },
                healthpro: {
                    title: "Professionnel de santé",
                    variable: {
                        profirstname:       "Prénom",
                        prolastname:        "Nom",
                        profullname:        "Nom complet",
                    }
                },
                entry: {
                    title: "Consultation",
                    variable: {
                        currentdate:        "Date",
                        currenttime:        "Heure",
                        currentlocation:    "Lieu"
                    }
                }
            },
            suggestions: {
                addVariable: "Rajouter une variable",
                autoUseFirst: "Remplissage automatique",
                autoSelection: "Sélection automatique",
                withConsultationDate: "avec la date de la consultation",
                withThisSelection: "avec cette sélection",
                withFirstSuggestion: "avec la 1e suggestion",
                required: "requis:",
                minimum: "minimum",
                examplesTitle: "Exemples",
                examples: {
                    lines: {
                        title: "Par ligne",
                        subtitle: "1 ligne = 1 suggestion",
                        example: "1x par mois\n1x par semaine\n1x tous les 2 jours"
                    },
                    blocks: {
                        title: "Par bloc",
                        subtitle: "Plusieurs lignes = 1 suggestion",
                        example: "J'adresse ce patient pour avis et rapport.\nIl présente: \n ---\nJ'adressse ce patient en urgence pour avis et rapport.\nIl présente:"
                    },
                    titledBlocks: {
                        title: "Par bloc avec titre",
                        subtitle: "Plusieurs lignes = 1 suggestion",
                        example: "--- Défaut\nJ'adresse ce patient pour avis et rapport.\nIl présente: \n\n --- En urgence\nJ'adressse ce patient en urgence pour avis et rapport.\nIl présente:"
                    }                                        
                }
            }
        },
        admin: {
            title: "Patient",
            relationship: {
                title: "Entourage",
                privatePatient:"Privé (patients)",
                privateCustom: "Privé (autres)",
                healthPro: "Professionnels de santé",
            },
            invoiceHistory: "Mémoires", 
            appointments: "Rendez-vous",            
            note: "Notes {note}",
            noteTitle: "Notes :",
            phone: "Téléphone fixe",
            mobile: "Téléphone mobile",
            birthday: "Date de naissance",
            gender: "Genre",
            langs: "Langue(s)",
            email: "Courriel",
            invalidEmail: "Email non valide",
            address: "Adresse",
            maps: "Voir",
            ssl: "Sécurité Sociale Luxembourgeoise",
            cnsNumber: {
                add: "Rajouter matricule",
                title: "Caisse Nationale de Santé",
                copied: "Copié"
            },
            cnsUpdate: {
                message: "Modification du CNS réussie avec succès",
            },
            cmcm: {
                title: "CMCM",
            },
            cmcmModify: {
                title: "Caisse médico-complémentaire mutualiste",
                useCmcm: "Inscrit CMCM",
            },            
            referringDoctor: {
                title: "Médecin référent",
                main: {
                    full: "Médecin référent principal",
                    short: "MR principal",
                },
                second: {
                    full: "Médecin référent remplaçant",
                    short: "MR remplaçant",
                },
                initialDeclarationDate: "Déclaration initiale",
                declarationNumber: "N° déclaration",
                createMrDeclaration: "Faire déclaration",
                createMrRpa: "Faire RPA",
            },
            doc: {
                resume: "Synthèse",
                prevention: "Fiche prévention",
                bill: "Mémoire d'honoraires"
            },
            subtitle: {
                contactDetail: "Coordonnées",
                identityDetail: "Identité",
                notificationDetail: "Préférences de notification"
            },
            subsubtitle: {
                contact: "Contacts",
                address: "Adresses",
                healthPro: "Professionnels de santé",
                cns: "CNS",
                cmcm: "CMCM",
                workAccident: "Accidents de travail",
                referringDoctor: "Médecin référent",
            },
            notification: {
                deliveryType: {
                    DELIVERY_EMAIL: 'Email',
                    DELIVERY_SMS: 'Sms',
                    DELIVERY_IN_APP: 'InApp'
                },
                preferredLanguage: 'Préférence de langue pour les communications',
                error: {
                    missingContactDetails: "Une ou plusieurs options sont désactivées car les informations nécessaires pour l'envoi de notification ne sont pas spécifiées."
                },
                noDefaultEmail: "Veuillez sélectionner un email par défaut pour changer les préférences de notifications par email."
            }
        },
        cns: {
            addCard: {
                title: "Matricule",
            },
            modifyCard: {
                title: "Matricule",
                useCnsNumber: "Utiliser matricule",
            },
            editAffiliationNumberCard: {
                title: "Modifier matricule",
                newCnsNumber: "Nouveau",
            },        
        },
        entourageCard: {
            person: "Personne",
            name: "Nom",
            birthName: "Nom de naissance",
            firstName: "Prénom",
            link: "Lien",
            birthDate: "Date de naissance",
            gender: "Genre administratif",
            biologicalSex: "Sexe biologique",
            languages: "Langue(s)",
            note: "Note",
            phone: "Numéro",
            email: "Email",
            street: "Rue",
            postalCode: "Code",
            locality: "Ville",
            country: "Pays",
            updateSuccess: "Modification des informations réussie",
        },
        actionButton: {
            accessPatient: "Dossier",
            newEntry: "Nouvelle entrée",
            accessCalendar: "RdV",
            createTask: "Tâche",
            scrollToTop: "Retour en haut",
        },
        filters: {
            bio: "Bio",
            imaging: "Imagerie",
            reports: "Rapports",
            other: "Autres",
            requests: "Prescriptions",
            users: "Utilisateur(s)",
            myConsultations: "Mes consultations",
        },
        entry: {
            time: "Heure de l'entrée",
            date: "Date de l'entrée",
            archive: {
                header: "Supprimer cette entrée",
                message: "Vous êtes sur le point de supprimer une entrée",
                confirm: "Suppression de l'entrée réussie"
            },
            archived: "Supprimée",
            archivedBy: "Supprimée par {author} le {deletedDate}",
            restore: {
                header: "Restaurer cette entrée",
                message: "Vous êtes sur le point de restaurer une entrée supprimée",
                confirm: "Restauration de l'entrée réussie"
            }
        },
        pharmacy: {
            suggestions: {
                stop: "Stop",
                favorites: "Favoris",
                lastPrescription: "Dernière prescription",
                moreSubstances: "+ Substances",
                lessSubstances: "Moins de substances",
                sameFamily: "Même famille",
                similarComposition: "Composition similaire"
            },
            prescriptionInfo: {
                patientInfos: "Informations patient",
                pharmacyInfos: "Informations pharmacie",
                autoUseFirst: "Auto-remplissage"
            },            
            posology: {
                then: "puis",
                asNeeded: "Si besoin",
                during: "pendant",
                stopIn: "arrêt dans",
                days: "jour(s)",
                infos: "infos",
                sequence: "séquence",
                preference: {
                    addCurrentDose: "Rajouter dose actuelle",
                    emptyToUseSubstance: "Laisser vide pour utiliser les posologies ci-dessous",
                    addPosologies: "Rajouter des posologies",
                    posologies: "Posologies",
                    posologiesPlaceholder: "1 comprimé matin et soir pendant 7 jours"
                }                
            },
            title: "Durée maximale de prescription",
            customDurationDays: "jours",
            DefaultDuration: "Défaut de l'ordonnance",
            CustomDuration: "Personnalisée",
            NotForPharmacy: "Jamais sur ordonnance",
            label: {
                DefaultDuration: "Ordonnance: durée max",
                CustomDuration: "Ordonnance: {days} jours",
                NotForPharmacy: "Hors ordonnance"
            },              
        },
        appointments: {
            empty: "Aucun rendez-vous",
            past: "Rendez-vous passés",
            coming: "Rendez-vous à venir",
            patientFullName: "Patient",
            healthProFullName: "Professionnel de santé",
            type: "Type du rendez-vous",
            date: "Date du rendez-vous",
            time: "Heure du rendez-vous",
            appointmentInfo: "Commentaires sur le rendez-vous",
            duration: "Durée du rendez-vous",
            appointmentDetails: "Détails du rendez-vous",
            minutes: "minutes",
            withoutAppointment: "Sans rendez-vous"
        }
    },
    task: {
        taskTerm: 'Tâche',
        mainTitle : 'Tâches',
        myMissionsTitle : 'Mes tâches',
        assignedMissionsTitle : 'Tâches déléguées',
        twoPersonTitle : 'Chat',
        emptyState: 'Aucune tâche',
        taskBoxCustomMenu : {
            addTaskBox : "Rajouter un canal",
        },
        twoPersonMenu : {
            addTaskBox : "Rajouter chat",
        },
        importFiles : {
            integrateRenamed: 'Intégrer fichiers renommés',
        },
        dropzone : {
            title: 'Rajouter fichiers',            
            subtitle: 'Cliquez ou glissez ici',
        },
        noteGroup: {
            missions: "Tâches",
            notes: "Notes",
            future: "Futurs",
            validated: "Validé"
        },
        taskPriority: {
            DuringShift: "1 - Rapidement",
            EndOfShift: "2 - Dans la journée",
            NextDays: "3 - Prochains jours",
            None: "4 - Moins urgent"
        },
        notePriority: {
            DuringShift: "1 - Très importante",
            EndOfShift: "2 - Importante",
            NextDays: "3 - Normale",
            None: "4 - Peu importante"
        },
        since: "à partir du ...",
        private: "Note privée",
        group: {
            message: {
                success: {
                    add: "Création du groupe de mission réussie",
                    deactivate: "Désactivation du groupe réussie",
                }
            }
        },
        import: {
            regibox: {
                message: {
                    startImport: {
                        summary: "Début de l'import Régibox",
                        detail: "Fichier(s): {fileNumber}",
                    },
                    endImport : {
                        summary: "Import Régibox",
                        detail: "Imports complets: {successful}\nImports partiels: {tasksCreated}\nEchecs: {failed}\n\n{errors}",
                    },
                    missingXmlData: "Fichiers sans .xml dans ce dossier\nMerci de les enlever d'abord",
                }
            }
        },
        status: {
            Pending: "Futurs",
            Settled: "Validés",
            Rename: "A renommer"
        },
        taskBoxDetail: {
            deactivate: "Désactiver ce canal"
        },
        taskBox: {
            creator: "Créateur",
        }
    },
    accounting: {
        noData: "Aucune facture trouvée",
        remainingBalance: "Solde restant",
        truncated: "Résultats limités",
        settled: "Payés",
        transaction: "Transaction",
        newTransaction: "Nouvelle transaction",        
        paymentType: "Type de paiement",
        search: {
            hasMore: "Résultats limités, affinez votre recherche",
            minCharacters: "Min 4 caractères ...",
        },
        editTransaction: {
            locked: "Cette transaction ne peut plus être modifiée",
        },                
        econnector: {
            service: {
                noPort: "eConnector: erreur de port",
                error: "eConnecteur: erreur",
                technicalError: "Erreur technique avec l'eConnecteur",
                unspecifiedError: "Erreur non spécifique",
            },
            pid: {
                title: "PID",
                unavailable: "PID indisponible",
                simulationRefused: "Simulation refusée",
                contest: "Contester",
                cnsPart: "Part CNS",
                patientPart: "Part patient",
                contestedOn: "Contesté le",
                redoSimulation: "Refaire simulation PID",
                confirm: "Confirmer"
            },
            ra: {
                title: "Remboursement accéléré",
                paidForCns: "PAYÉ pour la CNS",
                notPaidForCns: "NON PAYÉ pour la CNS",
                directTransmissionImpossible: "transmission CNS directe impossible",
                confirm: "Confirmer",
                withoutEConnector: "Sans eConnector"
            },            
            sendMh: {
                toast: {
                    error: "Erreur lors de l'envoi du mémoire d'honoraire à la CNS",
                    errorWithDetails: "Erreur(s) : {details}",
                    success: "Le mémoire d'honoraire a bien été transmis à la CNS"
                }
            },
            cancelMh: {
                toast: {
                    error: "Erreur lors de l'annulation du mémoire d'honoraire auprès de la CNS",
                    errorWithDetails: "Erreur(s) : {details}",
                    success: "Le mémoire d'honoraire a bien été annulé auprès de la CNS"
                },
                alreadyCancelled: "Ce mémoire a déjà été annulé",
                title: "Annulation",
                titleEconnector: "Annulation eConnector",
                transmittedViaEconnector: "Ce mémoire a été transmis via eConnector",
                cancellationImpossibleWithoutEconnector: "Annulation impossible sans eConnector",
                econnectorDisabled: "eConnector désactivé",
                econnectorUnavailable: "eConnector indisponible",
                cancelAmount: "Annuler montant",
                cancellationReason: "Motif d'annulation",
                required: "Requis",
                invoiceNumber: "Mémoire N°",
                invoiceDate: "Du",
                total: "Total"
            },
            pidSimulation: {
                toast: {
                    expiredSummary: "La simulation du PID a expiré",
                    expiredDetail: "Veuillez recommencer une nouvelle simulation",
                    error: "Erreur lors de la simulation du PID",
                    errorWithDetails: "Erreur(s) : {details}",
                    refused: "PID refusé",
                    stillValid: "Simulation PID encore valide",
                }
            },
            pidValidation: {
                toast: {
                    error: "Erreur lors de la validation du PID",
                    success: "Le PID a été validé avec succès",
                    errorWithDetails: "Erreur(s) : {details}",
                }
            },
            pidContestation: {
                selectAnomaly: "Veuillez sélectionner l'anomalie à contester",
                selectType: "Veuillez sélectionner le type de contestation",
                type: {
                    interpretation: "Contestation de l'interprétation d'une règle de tarification faite par le moteur de règles",
                    programatic: "Contestation d'une erreur de programmation du moteur de règles"
                },
                toast: {
                    error: "Erreur lors de la contestation du PID",
                    success: "Le PID a été contesté avec succès",
                    errorWithDetails: "Erreur(s) : {details}"
                }
            }
        },
        allMenu: {
            title: "Tous",
            precomplete: "A finaliser"
        },
        financialSummary: {
            cancelled: "Annulé",
            awaitingPayment: "En attente de paiement",
            revenues: "Recettes",
            directPayment: "Virement direct",
            includeImmediatePayments: "inclure PID et carte dans recettes",
        },
        financialGroupMenu: {
            disabled: "{groupName} (désactivé)",
            fixChannels: {
                remainingBalance: "Solde restant",
            },
            fixGroups: {
                tpCreatedOn: "Groupe du {date}",
                notSubmitted: "A faire",
            },
            groupActions: {
                downloadBills: "Télécharger mémoires",
                downloadActs: "Télécharger actes",
                downloadTransactions: "Télécharger transactions",
                exportForBob50: "Exporter pour BOB 50",
                openPidDashboard: "Historique des transmissions",
            },
            channelTransactions: {
                cancelled: "annuler",
                bankAccount: "par virement",
                cash: "en espèces",
                bankCard: "par carte",
                digitalPayment: "digital",
                luTp: "par TP",
                luTpSocial: "par TP social",
                luPid: "par PID",
                remainingBalance: "non payé",
            },
            channelActions: {
                createPaymentReminders: "Faire rappels",
                createLuTpSheet: "Créer fiche TP",
                createLuTpSocialSheet: "Créer groupe TP social",
            },
            searchInvoice: "Facture",
            luTpSheet: "Relevé CNS",
        },
        filterMenu: {
            patient: "Patient",
            date: "Date",
            healthPro: "Médecin",
        },
        infos: {
            title: "Mémoire(s)",
        },
        stats: {
            menu: {
                title: "Historique",
            },
            body: {
                title: "Historique de : {groupName}",
                nbMHSent: "Honoraires envoyés",
                nbPidValidated: "PID validés",
                nbPidContested: "PID contestés",
                period: "Du {start} au {end}"
            }
        },
        invoice: {
            notCns: "Hors CNS",
            reminder: "Rappel niveau {sequence}",
            invoices: "Facture(s):",
        },
        invoiceReminder: {
            letter: "Lettre",
            fee: "Frais",
            invoices: "Factures: ",
            selectionAlone: "Mémoires",
            selectionWithReminders: "Mémoires avec lettre",
            remindersWithSettled: "Rappels avec d'autres mémoires réglés",
            remindersNotPrinted: "{count} rappel(s) non imprimé — réglé depuis",
            reminders: "Rappels",
            reminder: "Rappel N° {sequence}",
            reminderSettings: {
                title: "Réglages",
                saved: "Réglages de rappel",                
            },
        },
    },
    login: {
        title: "Connexion",
        subtitle: "Veuillez choisir un moyen de connexion pour poursuivre",
        smartCard: "Se connecter avec LuxTrust SmartCard",
        mobile: "Se connecter avec LuxTrust Mobile",
        noAccount: "Vous n'avez pas de compte ?",
        askToBeContacted: "Demander à être contacté",
        needHelp: "Besoin d'aide ?",
        contactUs: "Nous contacter",
        welcome: "Bienvenue sur eSklepios",
        welcomeSubtitle: "Moins d'administratif, plus de soin",
        catchphrase: "La technologie au service de la santé",
        description: "Bénéficiez de puissants outils pour une meilleure prise en charge",
    },
    refSheet: {
        title: "Fiche",
        list: "Fiches",
        names: "Noms",
        searchRefSheet: "Chercher fiche",
        selectRefSheet: "Sélectionner une fiche",
        assessment: {
            signs: "Signes",
            prescriptionsFirst: "Prescriptions - 1e intention",
            prescriptionsSecond: "Prescriptions - 2e intention",
        },
        tabs: {
            Sheet: "Fiche",
            Presentation: "Tableau",
            Etio: "Etio",
            Complic: "Complic",
            Treatment: "Traitement",
            Invoice: "Facturation",
        },
        treatment: {
            medication: "Médicaments",
            healthPro: "Professionnels de santé",
            administratif: "Administratif",                        
        },
        invoice: {
            billingCodes: "Codes de facturation",
        },
        referenceDocument: {
            title: "Template",
            list: "Templates",
            create: "Créer template",
            newTitle: "Titre du template",
            newTitleExample: "p.ex. Rééducation initiale ou Rapport standard",
        },
        referenceLink: {
            title: "Lien référence",
            list: "Liens référence",
        },
        referenceFile: {
            title: "Fichier référence",
            list: "Fichiers référence",
        },
        patientFile: {
            title: "Document patient",
            list: "Documents patient",
        },
    },
    posos: {
        error: {
            loading: "Erreur lors du chargement du widget POSOS"
        },
        unresolved: {
            drugs: "Médicaments non analysés",
            strengthMismatches: "Approximations",
            conditions: "Antécédents non analysés",
            allergies: "Allergies non analysées"
        }
    }
};